import PaperContainer from "./PaperContainer";

export default PaperContainer;